import { render, staticRenderFns } from "./PageSave.vue?vue&type=template&id=5de596a4"
import script from "./PageSave.vue?vue&type=script&lang=js"
export * from "./PageSave.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports